import useSWR from 'swr';

import { fetchUnexpected, UNEXPECTED_MONTHS } from '../data/reportRepository.js';
import { summariseUnexpected, type UnexpectedSummary } from '../model/unexpectedSummary.js';

export type UnexpectedState =
  | { status: 'idle' }
  | { status: 'loading' }
  | { status: 'error'; message: string; retry: () => void }
  | { status: 'ready'; summary: UnexpectedSummary };

/** A year of declared surprises, already grouped into months. */
export function useUnexpected(subjectId: string | null): UnexpectedState {
  const key = subjectId === null ? null : `unexpected:${subjectId}:${UNEXPECTED_MONTHS}`;

  const { data, error, isLoading, mutate } = useSWR<UnexpectedSummary, Error>(
    key,
    async () => summariseUnexpected(await fetchUnexpected(subjectId!), UNEXPECTED_MONTHS),
    { revalidateOnFocus: false, shouldRetryOnError: false },
  );

  if (key === null) return { status: 'idle' };
  if (error) {
    return {
      status: 'error',
      message: error.message || 'Không tải được chi bất thường.',
      retry: () => {
        void mutate();
      },
    };
  }
  if (isLoading || data === undefined) return { status: 'loading' };

  return { status: 'ready', summary: data };
}
